
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $d80135daa5512541$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["5KWOc","index.0237a11a.js","hfmF4","orangeBg.67c6b9a3.jpg","kqfbX","blackBg.a7db649e.jpg","guL6b","whiteBg.bdc4e15a.jpg","ervP4","orangeDark.992e5f46.jpg","ffxCZ","multiBg.f0171e6c.jpg","2z7do","themeIco.938e28a8.svg","2HpMP","closeIco.b2523443.svg","hn9s5","orange.e1e5c19e.svg","kEOPj","right-arrow.e26353de.svg","foOc2","github.49dc7afd.svg","1UpAw","linked-in.aac163ce.svg","4Gp99","instagram.162a3198.svg","hPPjc","mail.74a7a289.svg","45JdQ","x.b9a06a50.svg","h5eiQ","typescript.9075684b.svg","7nhve","react-2.6b2118cf.svg","dD4nP","javascript.d7864fff.svg","1E0Dy","nextjs.72f3cb54.svg","fDkKC","project-img1.c7006de8.png","9XfHd","project-img2.32500b84.png","5c2HA","express.f635ccd6.svg","ezEOU","nodejs.a3419a77.svg","aRJ5g","mongodb.f3ec05fe.svg","hbN96","obs.c2e6da15.svg","iysBt","slices.7de43cc9.svg","5v78p","index.b261f7ba.css"]'));


//# sourceMappingURL=index.runtime.297c66b7.js.map
